module.exports = __webpack_public_path__ + "img/simulations-white.49179a7e.svg";